//core
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './gt.routing.module';
import { TabsComponent } from './tabs/tabs.component';
import { TabComponent } from './tabs/tab.component';
import { DatePipe } from '@angular/common';
import { TruncatePipe } from 'src/app/truncate.pipe';
//services
import { ResponsiveService } from './_services/responsive.service';
import { LoaderService } from './loader/loader.service';
import { OrgService } from './_services/org.service';
import { StudentService } from './_services/student.service';
import { ConfigService } from './_services/config.service';
import { AuthenticationService } from './_services/authentication.service';
import { PrintService } from './_services/print.service';
import { PhaseService } from './_services/phase.service';
import { ExportJsonService } from 'src/app/_services/export-json.service';
import { ScoreStorageService } from 'src/app/_services/score-storage.service';
import { DocumentManagementService } from './documents/document-management.service';
//interceptors
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { LoaderInterceptor } from './loader/loading.interceptor';
import { HttpRequestInterceptor } from './_helpers/http.interceptor';
import { HttpMockRequestInterceptor } from './_helpers/mock.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';

//components
import { AppComponent } from './gt.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { MessageComponent } from './message/message.component';
import { ForgotpasswordComponent } from './forgot-password/forgotpassword.component';
import { StudentListComponent } from './student-list/student-list.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardTeacherComponent } from './dashboard-teacher/dashboard.component';
import { DashboardPrincipalComponent } from './dashboard-principal/dashboard.component';
import { DashboardAreaComponent } from './dashboard-area/dashboard-area.component';
import { LoaderComponent } from './loader/loader.component';
import { ResetpwdComponent } from './resetpwd/resetpwd.component';
import { FirsttimeloginComponent } from './first-time-login/firsttimelogin.component';
import { StudentCardComponent } from './student-card/student-card.component';
import { AnimatedDigitComponent } from './animated-digit.component/animated-digit.component';

//pipes
import { SearchPipe } from './_pipes/search.pipe';
import { PluralSingularPipe } from './_pipes/plural-singular.pipe';
import { SumPipe } from './_pipes/sum.pip';
import { OriginalOrderPipe } from './_pipes/original-order.pipe';
//libs
import { RoundProgressModule } from 'angular-svg-round-progressbar';

import { AgGridModule } from 'ag-grid-angular';

import { TimeGraphComponent } from './time-graph/time-graph.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TestWindowComponent } from './test-window/test-window.component';
import { PhonicsAdvComponent } from './phonics-adv/phonics-adv.component';
import { TestHistoryComponent } from './test-history/test-history.component';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { EachbarComponent } from './eachbar/eachbar.component';
import { AssessmentsBarComponent } from './assessments-bar/assessments-bar.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';

import { DropdownSchoolComponent } from './dropdown-school/dropdown-school.component';
import { DropdownClassroomComponent } from './dropdown-classroom/dropdown-classroom.component';
import { DropdownAreaComponent } from './dropdown-area/dropdown-area.component';
import { DropdownDistrictComponent } from './dropdown-district/dropdown-district.component';
import { ProgressBarSchoolComponent } from './progress-bar-school/progress-bar-school.component';
import { ProgressBarClassroomComponent } from './progress-bar-classroom/progress-bar-classroom.component';
import { OptionsMenu } from './options-menu/options-menu.component';
import { OfflineDetectorComponent } from './offline-detector/offline-detector.component';
import { EditQuestionsComponent } from './edit-questions/edit-questions.component';
import { PhaseSelectComponent } from './phase-select/phase-select.component';
import { ChildNotesComponent } from './child-notes/child-notes.component';
import { ChildNoteDetailComponent } from './child-notes/child-note.detail.component';
import { AutofocusDirective } from './autofocus.directive';
import { RawBalloonComponent } from './raw-balloon/raw-balloon.component';
import { TestHistoryAllComponent } from './test-history-all/test-history-all.component';
import { DownloadNotesButtonComponent } from './child-notes/download-notes-button/download-notes-button.component';
import { ExportDataCardComponent } from './child-notes/export-data-card/export-data-card.component';
import { DownloadTableButtonComponent } from './download-table-button/download-table-button.component';
import { HasPermissionDirective } from 'src/_directives/has-permission.directive';
import { OffCanvasComponent } from './off-canvas/off-canvas.component';
import { RawFilterComponent } from './filters/raw-filter/raw-filter.component';
import { NotificationComponent } from 'src/app/notification/notification.component';
import { StripHtmlPipe } from './strip-html.pipe';
import { ResizableDirective } from './resizable.directive';
import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { LandingComponent } from './landing/landing.component';
import { QuickStatsComponent } from './landing/quick-stats/quick-stats.component';
import { NumberOfStudentsPerChallengeComponent } from './charts/number-of-students-per-challenge/number-of-students-per-challenge.component';
import { LineChartComponent } from './assesments/line-chart/line-chart.component';
import { DocumentsComponent } from './documents/documents.component';
import { ManageDocumentsComponent } from 'src/app/documents/admin/manage-documents.component';
import { FileSizePipe } from './_pipes/file-size.pipe';
import { FileTypePipe } from './_pipes/file-type.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ParaShellModule } from '@para/shell/para-shared-layout.module';
import { ProgressTableComponent } from './progress-table/progress-table.component';
import { ProgressAccordionComponent } from './progress-table-accordion/progress-table-accordion.component';
import { ComponentLoaderComponent } from './component-loader/component-loader.component';
import { ReadingAchievementPhasesComponent } from './reading-achievement-phases/reading-achievement-phases.component';
import { FooterComponent } from './footer/footer.component';
import { ToastsContainer } from './toast-global/toast-container.component';
import { TreeFilterComponent } from './tree/tree-filter/tree-filter.component';

export const isMock = environment.mock;

declare global {
	interface Window {
		analytics: any;
	}
}

// function load(config: ConfigService) {
// 	return () => {
// 		return new Promise<void>((resolve) => {
// 			config.loadConfig();
// 			resolve();
// 		});
// 	};
// }

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		HeaderComponent,
		MessageComponent,
		ForgotpasswordComponent,
		DashboardComponent,
		DashboardTeacherComponent,
		DashboardPrincipalComponent,
		DashboardAreaComponent,
		LoaderComponent,
		ResetpwdComponent,
		TimeGraphComponent,
		TestWindowComponent,
		PhonicsAdvComponent,
		StudentListComponent,
		SearchPipe,
		TruncatePipe,
		SumPipe,
		OriginalOrderPipe,
		PluralSingularPipe,
		FirsttimeloginComponent,
		StudentCardComponent,
		AnimatedDigitComponent,
		TestHistoryComponent,
		ProgressTableComponent,
		ProgressAccordionComponent,
		ComponentLoaderComponent,
		ReadingAchievementPhasesComponent,
		FooterComponent,
		ToastsContainer,
		TreeFilterComponent,
		EachbarComponent,
		AssessmentsBarComponent,
		DashboardAdminComponent,
		DropdownSchoolComponent,
		DropdownClassroomComponent,
		DropdownAreaComponent,
		DropdownDistrictComponent,
		ProgressBarSchoolComponent,
		ProgressBarClassroomComponent,
		TabsComponent,
		TabComponent,
		OptionsMenu,
		OfflineDetectorComponent,
		EditQuestionsComponent,
		PhaseSelectComponent,
		ChildNotesComponent,
		ChildNoteDetailComponent,
		AutofocusDirective,
		RawBalloonComponent,
		TestHistoryAllComponent,
		DownloadNotesButtonComponent,
		ExportDataCardComponent,
		DownloadTableButtonComponent,
		HasPermissionDirective,
		OffCanvasComponent,
		RawFilterComponent,
		NotificationComponent,
		StripHtmlPipe,
		FileSizePipe,
		FileTypePipe,
		ResizableDirective,
		DashboardLayoutComponent,
		AuthLayoutComponent,
		LandingComponent,
		QuickStatsComponent,
		NumberOfStudentsPerChallengeComponent,
		LineChartComponent,
		DocumentsComponent,
		ManageDocumentsComponent,
	],
	imports: [
		AppRoutingModule,
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		DragDropModule,
		RoundProgressModule,
		ReactiveFormsModule,
		FormsModule,
		NgbModule,
		AgGridModule.withComponents([]),
		ParaShellModule,
	],
	providers: [
		DatePipe,
		LoaderService,
		ResponsiveService,
		StudentService,
		OrgService,
		AuthenticationService,
		PrintService,
		PhaseService,
		ExportJsonService,
		DocumentManagementService,
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },

		{
			provide: HTTP_INTERCEPTORS,
			useClass: isMock ? HttpMockRequestInterceptor : HttpRequestInterceptor,
			multi: true,
		},
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		{ provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
		JwtHelperService,
	],
	entryComponents: [PhonicsAdvComponent],
	bootstrap: [AppComponent],
})
export class GtModule {}
